import { render, staticRenderFns } from "./modalEditAppParamsKey.vue?vue&type=template&id=470e1130&"
import script from "./modalEditAppParamsKey.vue?vue&type=script&lang=js&"
export * from "./modalEditAppParamsKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports